var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 2.22727,
    stroke: "#facc15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.4091V13",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4091 8H23",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.59091V3",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8H14.5909",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.5L21.6364 4.13636",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.5L14.3636 4.13636",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.5L21.6364 11.8636",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.5L14.3636 11.8636",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 20H11.4762H20.381C21.254 20 23 19.5 23 17.5C23 16.6802 22.4931 15.0541 20.4821 15.0013C20.4268 14.9999 20.3812 14.9545 20.379 14.8993C20.2852 12.5336 16.899 11.1267 14.8094 13.745C14.7484 13.8214 14.6143 13.7803 14.6073 13.6828C14.4819 11.945 13.3198 9 9.38095 9C7.64981 9 4.2023 9.98302 4.14362 13.8983C4.14279 13.9535 4.0981 13.9999 4.04291 14.0018C2.96784 14.0388 1 14.6741 1 17C1 18 1.62857 20 4.14286 20Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02D);
export default __webpack_public_path__ + "static/media/02d.13b059ad77f07d50c1e9a986b627c003.svg";
export { ForwardRef as ReactComponent };